import React from "react";

import PendingGroup from "./PendingGroup";

import { PendingGroupsContainer } from "./styles";

import { mockDataList } from "frontend/components/core/JustifiedGrid/__mocks__/index.js";

const PendingGroups = () => (
    <PendingGroupsContainer>
        <PendingGroup itemData={mockDataList} />
        <PendingGroup itemData={mockDataList} />
    </PendingGroupsContainer>
);

export default PendingGroups;
